import { Box, Button, DialogContent, DialogTitle, ModalClose, ModalDialog } from "@mui/joy";
import { FormProvider, useForm } from "react-hook-form";

import { useBulkUpdateRoutesMutation, useRoutesByUuids } from "../../hooks/routes";
import { useCurrentClimbType } from "../../hooks/venues";
import CircuitSelect from "../forms/CircuitSelect";
import LineSelect from "../forms/LineSelect";
import { RouteName } from "../RoutesTable/RouteName";
import { useModal } from "./useModal";

export const MoveRoutes = ({ routeUuids }: { routeUuids: string[] }) => {
  const { close } = useModal();

  const routes = useRoutesByUuids(routeUuids);
  const climbType = useCurrentClimbType();

  const { formState, ...methods } = useForm({
    defaultValues: {
      circuit: routes[0].circuit?.uuid,
      line: routes[0].startLine?.uuid,
    },
  });

  const mutation = useBulkUpdateRoutesMutation();

  const onSubmit = async (data: { circuit?: string; line?: string }) => {
    const patches = routeUuids.map((uuid) => ({
      uuid,
      ...(climbType === "BOULDER" ? { circuit: data.circuit } : { startLine: data.line }),
    }));
    await mutation.mutateAsync(patches);
    close();
  };

  return (
    <ModalDialog>
      <ModalClose />
      <DialogTitle>
        {routes.length === 1 ? (
          <>
            Move route:{" "}
            <Box sx={{ display: "inline-flex", alignItems: "center" }}>
              <RouteName route={routes[0]} />
            </Box>
          </>
        ) : (
          <>Move {routes.length} routes</>
        )}
      </DialogTitle>
      <DialogContent>
        <FormProvider formState={formState} {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            {climbType === "BOULDER" ? (
              <CircuitSelect name="circuit" />
            ) : (
              <LineSelect name="line" />
            )}

            <Button
              sx={{ width: "100%", mt: 1 }}
              type="submit"
              loading={formState.isSubmitting}
              loadingPosition="start"
            >
              {formState.isSubmitting ? "Moving..." : "Move"}
            </Button>
          </form>
        </FormProvider>
      </DialogContent>
    </ModalDialog>
  );
};
